
export default {
  name: 'IconPerson',
};
